
export default {
  name: 'IconPerson',
};
